import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type ChannelPaymentFormData = {
  walletId: string
  displayCurrency: string
  payCurrency: string
  reference: string
}

export type ChannelPaymentFormKeys = keyof ChannelPaymentFormData

export const useChannelPaymentSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField } = useYupFields()

  return yup.object<Record<ChannelPaymentFormKeys, yup.AnySchema>>({
    walletId: getRequiredYupField({
      label: t('formFields.wallet'),
    }),
    displayCurrency: getRequiredYupField({
      label: t('formFields.displayCurrency'),
    }),
    payCurrency: getRequiredYupField({
      label: t('formFields.payCurrency'),
    }),
    reference: getRequiredYupField({
      label: t('formFields.channelReference'),
    }),
  })
}
